module.exports = __webpack_public_path__ + "static/img/share-cover.17677df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/groupDetail/share-cover.png
// module id = PuYy
// module chunks = 17